module.exports = __webpack_public_path__ + "media/images/daodi-logo-1b36225f1b3799dbfc67fb84558b8ac5.jpg";